import CloseButton from 'src/components/Buttons/CloseButton';
import config from 'src/constants/config';
import DateFormat from '../../../utils/dateFormat';
import IconButton from 'src/components/Buttons/IconButton';
import Input from '../../Forms/Input';
import Modal from '../../../utils/modal';
import moment from '../../../utils/moment';
import NormalButton from '../../Buttons/NormalButton';
import React, { useCallback, useRef } from 'react';
import RichTextEditor from 'src/components/Forms/RichTextEditor';
import Select from '../../Forms/Select';
import StorageService from 'src/services/storage.service';
import SVG from 'src/components/Images/SvgRenderer';
import Switch from 'src/components/Forms/Switch';
import theme from 'src/ui/theme';
import useStyles from './style';
import { CircularProgress, useMediaQuery } from '@mui/material';
import { createNotification } from '../../../utils/createNotification';
import { filterEmptyValues, filterNotExistingValues, isKey } from 'src/utils/useFunctions';
import { getUserSetting } from 'src/utils/useUser';
import { isCypress } from '../../../utils/useCypress';
import { removeClassbookAlert, setClassbookAlerts, updateClassbookList } from '../../../store/actions/classbook.actions';
import { setClassbookHandleModal, setConfirmModal, setDraftsModal } from '../../../store/actions/modals.actions';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux-hooks';
import { useEffect } from 'src/utils/useEffect';
import { useState, useStates } from '../../../utils/useState';
import { useTranslation } from 'react-i18next';

const ClassbookHandleModal: React.FunctionComponent = () => {

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const browserData = useAppSelector((state: any) => state.browser);
  const classbookData = useAppSelector((state: any) => state.classbook);
  const dataData = useAppSelector((state: any) => state.data);
  const languageData = useAppSelector((state: any) => state.language);
  const modalsData = useAppSelector((state: any) => state.modals);
  const userData = useAppSelector((state: any) => state.user);
  const classbookService = useAppSelector((state: any) => state.services).classbookService;
  const smallDevice = useMediaQuery(theme.breakpoints.down('md'));

  const curClass = modalsData.classbookHandleModal.classID;
  const curDate = modalsData.classbookHandleModal.date;
  const curDates = modalsData.classbookHandleModal.dates;
  const recordDates = modalsData.classbookHandleModal.recordDates;

  const modalRef: any = useRef(null);
  const headerRef: any = useRef(null);
  const footerRef: any = useRef(null);

  const getClassData = useCallback((classID: any) => {
    return dataData.classes.filter((item: any) => item.classID === classID).length === 0 ? [] : dataData.classes.find((item: any) => item.classID === classID);
  }, [dataData.classes]);

  const classbookType = getClassData(curClass).classbookType;
  const isSchoolCare = getClassData(curClass).isSchoolCare;
  const isImport = modalsData.classbookHandleModal.isImport;
  const importData = modalsData.classbookHandleModal.importData;
  const startDate = (classbookType === "weekly" && curDates) ? moment(curDates[0]).format("YYYY-MM-DD") : moment(curDate).startOf('isoWeek').format("YYYY-MM-DD");
  const endDate = (classbookType === "weekly" && curDates) ? moment(curDates[1]).format("YYYY-MM-DD") : moment(curDate).endOf('isoWeek').format("YYYY-MM-DD");
  const dateFrom = (classbookType === "weekly" && recordDates) ? moment(recordDates[0]).format("YYYY-MM-DD") : moment(curDate).format("YYYY-MM-DD");
  const dateTo = (classbookType === "weekly" && recordDates) ? moment(recordDates[1]).format("YYYY-MM-DD") : moment(curDate).format("YYYY-MM-DD");

  const list = classbookData.list;
  const recordDaily = list.filter((item: any) => item.classID === curClass && moment(item.startDate).format("YYYY-MM-DD") === startDate && moment(item.endDate).format("YYYY-MM-DD") === endDate).length === 0 ? null : (list.find((item: any) => item.classID === curClass && moment(item.startDate).format("YYYY-MM-DD") === startDate && moment(item.endDate).format("YYYY-MM-DD") === endDate).records.filter((item: any) => moment(item.date).format("YYYY-MM-DD") === moment(curDate).format("YYYY-MM-DD")).length === 0 ? null : list.find((item: any) => item.classID === curClass && moment(item.startDate).format("YYYY-MM-DD") === startDate && moment(item.endDate).format("YYYY-MM-DD") === endDate).records.find((item: any) => moment(item.date).format("YYYY-MM-DD") === moment(curDate).format("YYYY-MM-DD")));
  const recordWeekly = list.filter((item: any) => item.classID === curClass && moment(item.startDate).format("YYYY-MM-DD") === startDate && moment(item.endDate).format("YYYY-MM-DD") === endDate).length === 0 ? null : (list.find((item: any) => item.classID === curClass && moment(item.startDate).format("YYYY-MM-DD") === startDate && moment(item.endDate).format("YYYY-MM-DD") === endDate).records.filter((item: any) => moment(item.dateFrom).format("YYYY-MM-DD") === moment(dateFrom).format("YYYY-MM-DD") && moment(item.dateTo).format("YYYY-MM-DD") === moment(dateTo).format("YYYY-MM-DD")).length === 0 ? null : list.find((item: any) => item.classID === curClass && moment(item.startDate).format("YYYY-MM-DD") === startDate && moment(item.endDate).format("YYYY-MM-DD") === endDate).records.find((item: any) => moment(item.dateFrom).format("YYYY-MM-DD") === moment(dateFrom).format("YYYY-MM-DD") && moment(item.dateTo).format("YYYY-MM-DD") === moment(dateTo).format("YYYY-MM-DD")));
  const recordDraft = classbookType === "weekly" ? recordWeekly : recordDaily;
  const notesInput: any = useRef({});

  const isDraftEnabled = getUserSetting(userData.userSettings, "addons", ["classbook", "classbook_drafts"]);
  const isAutosaveEnabled = getUserSetting(userData.userSettings, "addons", ["classbook", "classbook_autosave"]);

  const [draft, setDraft, setWholeDraft] = useStates(null);
  
  const isMissingInfoEnabled = getUserSetting(userData.userSettings, "addons", ["classbook", "classbook_missing_inputs"]);

  const getDrafts = () => {
    const isLocalStorageExist = StorageService.existItem(config.LOCALSTORAGE_CLASSBOOK_DRAFTS);
    if(isLocalStorageExist) {
      const localStorageDrafts = StorageService.getItem(config.LOCALSTORAGE_CLASSBOOK_DRAFTS).map((item: any) => { return {...item, storage: "localStorage"}; });
      const userDataStorageDrafts = getUserSetting(userData.userSettings, "drafts", ["classbook"]).map((item: any) => { return {...item, storage: "userDataStorage"}; });
      return [...localStorageDrafts, ...userDataStorageDrafts];
    } else {
      const localStorageDrafts: any = [];
      const userDataStorageDrafts = getUserSetting(userData.userSettings, "drafts", ["classbook"]).map((item: any) => { return {...item, storage: "userDataStorage"}; });
      StorageService.setItem(config.LOCALSTORAGE_CLASSBOOK_DRAFTS, localStorageDrafts);
      return [...localStorageDrafts, ...userDataStorageDrafts];
    }
  };

  const getDraftID = () => {
    return moment().valueOf();
  };

  const saveDraftToTempStorage = (newDraft: any) => {
    StorageService.setItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT, filterEmptyValues(newDraft));
  };

  const saveDraftToLocalStorage = (newDraft: any) => {
    const localStorageDrafts = getDrafts().filter((item: any) => item.storage === "localStorage");
    const newDrafts = [...localStorageDrafts, filterEmptyValues(newDraft)];
    StorageService.setItem(config.LOCALSTORAGE_CLASSBOOK_DRAFTS, newDrafts);
  };

  const [state, setState] = useStates({
    isLoaded: getUserSetting(userData.userSettings, "addons", ["classbook", "classbook_record_autoupdate"]) ? false : true,
    draftID: isDraftEnabled ? getDraftID() : null,
    updateRefs: false,
    bodyHeight: null,
    modalIsFullscreen: smallDevice ? true : false,
    canClick: true,
    instructions: [],
    isImported: false,
    isKeepDraftAfterUse: false,
  });

  const classes = useStyles({
    isFullscreen: state.modalIsFullscreen,
    bodyHeight: state.bodyHeight,
  });
  
  const getRecord = () => {
    if(classbookType === "daily") {
      if(isSchoolCare) {
        if(recordDraft === null) {
          return {
            classID: curClass,
            date: moment(curDate).format("YYYY-MM-DD"),
            notes: '',
            interestActivities: '',
            relaxationRecreationalActivities: '',
            preparationTeaching: '',
            otherActivities: '',
            internalNote: '',
          };
        } else {
          return {
            classID: curClass,
            date: moment(curDate).format("YYYY-MM-DD"),
            notes: recordDraft.notes ? recordDraft.notes : "",
            interestActivities: recordDraft.interestActivities ? recordDraft.interestActivities : "",
            relaxationRecreationalActivities: recordDraft.relaxationRecreationalActivities ? recordDraft.relaxationRecreationalActivities : "",
            preparationTeaching: recordDraft.preparationTeaching ? recordDraft.preparationTeaching : "",
            otherActivities: recordDraft.otherActivities ? recordDraft.otherActivities : "",
            internalNote: recordDraft.internalNote ? recordDraft.internalNote : "",
          };
        }
      } else {
        if(recordDraft === null) {
          return {
            classID: curClass,
            date: moment(curDate).format("YYYY-MM-DD"),
            theme: '',
            morning: '',
            afternoon: '',
            morningRaw: '',
            afternoonRaw: '',
            notes: '',
            visit: '',
          };
        } else {
          return {
            classID: curClass,
            date: moment(curDate).format("YYYY-MM-DD"),
            theme: recordDraft.theme ? recordDraft.theme : "",
            morning: recordDraft.morning ? recordDraft.morning : "",
            afternoon: recordDraft.afternoon ? recordDraft.afternoon : "",
            morningRaw: recordDraft.morningRaw ? recordDraft.morningRaw : "",
            afternoonRaw: recordDraft.afternoonRaw ? recordDraft.afternoonRaw : "",
            notes: recordDraft.notes ? recordDraft.notes : "",
            visit: recordDraft.visit ? recordDraft.visit : "",
          };
        }
      }
    } else if(classbookType === "weekly") {
      if(isSchoolCare) {
        if(recordDraft === null) {
          return {
            classID: curClass,
            date: moment(curDates[0]).format("YYYY-MM-DD"),
            startDate: moment(curDates[0]).format("YYYY-MM-DD"),
            endDate: moment(curDates[1]).format("YYYY-MM-DD"), 
            week: '',
            notes: '',
            interestActivities: '',
            relaxationRecreationalActivities: '',
            preparationTeaching: '',
            otherActivities: '',
            internalNote: '',
          };
        } else {
          return {
            classID: curClass,
            date: moment(recordDraft.dateFrom).format("YYYY-MM-DD"),
            startDate: moment(recordDraft.dateFrom).format("YYYY-MM-DD"),
            endDate: moment(recordDraft.dateTo).format("YYYY-MM-DD"), 
            week: recordDraft.week ? recordDraft.week : "",
            notes: recordDraft.notes ? recordDraft.notes : "",
            interestActivities: recordDraft.interestActivities ? recordDraft.interestActivities : "",
            relaxationRecreationalActivities: recordDraft.relaxationRecreationalActivities ? recordDraft.relaxationRecreationalActivities : "",
            preparationTeaching: recordDraft.preparationTeaching ? recordDraft.preparationTeaching : "",
            otherActivities: recordDraft.otherActivities ? recordDraft.otherActivities : "",
            internalNote: recordDraft.internalNote ? recordDraft.internalNote : "",
          };
        }
      } else {
        if(recordDraft === null) {
          return {
            classID: curClass,
            date: moment(curDates[0]).format("YYYY-MM-DD"),
            startDate: moment(curDates[0]).format("YYYY-MM-DD"),
            endDate: moment(curDates[1]).format("YYYY-MM-DD"), 
            week: '',
            theme: '',
            morning: '',
            afternoon: '',
            morningRaw: '',
            afternoonRaw: '',
            notes: '',
            visit: '',
          };
        } else {
          return {
            classID: curClass,
            date: moment(recordDraft.dateFrom).format("YYYY-MM-DD"),
            startDate: moment(recordDraft.dateFrom).format("YYYY-MM-DD"),
            endDate: moment(recordDraft.dateTo).format("YYYY-MM-DD"), 
            week: recordDraft.week ? recordDraft.week : "",
            theme: recordDraft.theme ? recordDraft.theme : "",
            morning: recordDraft.morning ? recordDraft.morning : "",
            afternoon: recordDraft.afternoon ? recordDraft.afternoon : "",
            morningRaw: recordDraft.morningRaw ? recordDraft.morningRaw : "",
            afternoonRaw: recordDraft.afternoonRaw ? recordDraft.afternoonRaw : "",
            notes: recordDraft.notes ? recordDraft.notes : "",
            visit: recordDraft.visit ? recordDraft.visit : "",
          };
        };
      }
    };
  };

  const getValues = useCallback((customData?: any) => {
    const recordDataValues = customData ? customData : recordDraft;
    if(classbookType === "daily") {
      if(isSchoolCare) {
        if(recordDataValues === null) {
          return {
            classID: curClass,
            date: moment(curDate).format("YYYY-MM-DD"),
            notes: '',
            interestActivities: '',
            relaxationRecreationalActivities: '',
            preparationTeaching: '',
            otherActivities: '',
            internalNote: '',
          };
        } else {
          return {
            classID: curClass,
            date: moment(curDate).format("YYYY-MM-DD"),
            notes: recordDataValues.notes ? recordDataValues.notes : "",
            interestActivities: recordDataValues.interestActivities ? recordDataValues.interestActivities : "",
            relaxationRecreationalActivities: recordDataValues.relaxationRecreationalActivities ? recordDataValues.relaxationRecreationalActivities : "",
            preparationTeaching: recordDataValues.preparationTeaching ? recordDataValues.preparationTeaching : "",
            otherActivities: recordDataValues.otherActivities ? recordDataValues.otherActivities : "",
            internalNote: recordDataValues.internalNote ? recordDataValues.internalNote : "",
          };
        }
      } else {
        if(recordDataValues === null) {
          return {
            classID: curClass,
            date: moment(curDate).format("YYYY-MM-DD"),
            theme: '',
            morning: '',
            afternoon: '',
            morningRaw: '',
            afternoonRaw: '',
            notes: '',
            visit: '',
          };
        } else {
          return {
            classID: curClass,
            date: moment(curDate).format("YYYY-MM-DD"),
            theme: recordDataValues.theme ? recordDataValues.theme : "",
            morning: recordDataValues.morning ? recordDataValues.morning : "",
            afternoon: recordDataValues.afternoon ? recordDataValues.afternoon : "",
            morningRaw: recordDataValues.morningRaw ? recordDataValues.morningRaw : "",
            afternoonRaw: recordDataValues.afternoonRaw ? recordDataValues.afternoonRaw : "",
            notes: recordDataValues.notes ? recordDataValues.notes : "",
            visit: recordDataValues.visit ? recordDataValues.visit : "",
          };
        }
      }
    } else if(classbookType === "weekly") {
      if(isSchoolCare) {
        if(recordDataValues === null) {
          return {
            classID: curClass,
            date: moment(curDates[0]).format("YYYY-MM-DD"),
            startDate: moment(curDates[0]).format("YYYY-MM-DD"),
            endDate: moment(curDates[1]).format("YYYY-MM-DD"), 
            week: '',
            notes: '',
            interestActivities: '',
            relaxationRecreationalActivities: '',
            preparationTeaching: '',
            otherActivities: '',
            internalNote: '',
          };
        } else {
          return {
            classID: curClass,
            date: moment(recordDataValues.dateFrom).format("YYYY-MM-DD"),
            startDate: moment(recordDataValues.dateFrom).format("YYYY-MM-DD"),
            endDate: moment(recordDataValues.dateTo).format("YYYY-MM-DD"), 
            week: recordDataValues.week ? recordDataValues.week : "",
            notes: recordDataValues.notes ? recordDataValues.notes : "",
            interestActivities: recordDataValues.interestActivities ? recordDataValues.interestActivities : "",
            relaxationRecreationalActivities: recordDataValues.relaxationRecreationalActivities ? recordDataValues.relaxationRecreationalActivities : "",
            preparationTeaching: recordDataValues.preparationTeaching ? recordDataValues.preparationTeaching : "",
            otherActivities: recordDataValues.otherActivities ? recordDataValues.otherActivities : "",
            internalNote: recordDataValues.internalNote ? recordDataValues.internalNote : "",
          };
        }
      } else {
        if(recordDataValues === null) {
          return {
            classID: curClass,
            date: moment(curDates[0]).format("YYYY-MM-DD"),
            startDate: moment(curDates[0]).format("YYYY-MM-DD"),
            endDate: moment(curDates[1]).format("YYYY-MM-DD"), 
            week: '',
            theme: '',
            morning: '',
            afternoon: '',
            morningRaw: '',
            afternoonRaw: '',
            notes: '',
            visit: '',
          };
        } else {
          return {
            classID: curClass,
            date: moment(recordDataValues.dateFrom).format("YYYY-MM-DD"),
            startDate: moment(recordDataValues.dateFrom).format("YYYY-MM-DD"),
            endDate: moment(recordDataValues.dateTo).format("YYYY-MM-DD"), 
            week: recordDataValues.week ? recordDataValues.week : "",
            theme: recordDataValues.theme ? recordDataValues.theme : "",
            morning: recordDataValues.morning ? recordDataValues.morning : "",
            afternoon: recordDataValues.afternoon ? recordDataValues.afternoon : "",
            morningRaw: recordDataValues.morningRaw ? recordDataValues.morningRaw : "",
            afternoonRaw: recordDataValues.afternoonRaw ? recordDataValues.afternoonRaw : "",
            notes: recordDataValues.notes ? recordDataValues.notes : "",
            visit: recordDataValues.visit ? recordDataValues.visit : "",
          };
        };
      }
    };
  }, [classbookType, curClass, curDate, curDates, isSchoolCare, recordDraft]);

  const record: any = getRecord();
  const [values, setValues] = useState(getValues());

  const isEmpty = isSchoolCare ? (record === null ? true : ((record.interestActivities === "" && record.relaxationRecreationalActivities === "" && record.preparationTeaching === "" && record.otherActivities === "" && record.internalNote === "") ? true : false)) : (record === null ? true : ((record.theme === "" && record.morning === "" && record.afternoon === "" && record.notes === "" && record.visit === "") ? true : false));
  const isChanged = isSchoolCare ? (record === null ? false : ((record.interestActivities !== values.interestActivities || record.relaxationRecreationalActivities !== values.relaxationRecreationalActivities || record.preparationTeaching !== values.preparationTeaching || record.otherActivities !== values.otherActivities || record.internalNote !== values.internalNote) ? true : false)) : (record === null ? false : ((record.theme !== values.theme || record.morningRaw !== values.morningRaw || record.afternoonRaw !== values.afternoonRaw || record.notes !== values.notes || record.visit !== values.visit) ? true : false));
  const isEmptied = isSchoolCare ? (record === null ? false : ((values.interestActivities === "" && values.relaxationRecreationalActivities === "" && values.preparationTeaching === "" && values.otherActivities === "" && values.internalNote === "") ? true : false)) : (record === null ? false : ((values.theme === "" && values.morningRaw === "" && values.afternoonRaw === "" && values.notes === "" && values.visit === "") ? true : false));
 
  const onCloseModal = () => {
    const settings = {
      isOpen: false,
      classID: null,
      date: null,
      dates: null,
      isImport: false,
      importData: null,
    };
    dispatch(setClassbookHandleModal(settings));
  };

  const handleImmediateDraftSave = () => {
    const draftData = StorageService.getItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT);
    saveDraftToLocalStorage({...draftData, draftID: state.draftID, draftDate: moment(), classbookType: classbookType, isSchoolCare: isSchoolCare });
    StorageService.removeItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT);
  };

  const handleFullscreen = () => {
    setState("modalIsFullscreen", !state.modalIsFullscreen);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    if(isDraftEnabled && StorageService.existItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT)) {
      const onSave = () => {
        handleImmediateDraftSave();
        onCloseModal();
      };
      const onNotSave = () => {
        StorageService.removeItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT);
        onCloseModal();
      };
      const settings = {
        isOpen: true,
        title: t('unsaved_changes'),
        content: t('draft_not_saved_confirm'),
        onAccept: onSave,
        onDecline: onNotSave,
      };
      dispatch(setConfirmModal(settings));
      return;
    }
    if(isChanged) {
      const settings = {
        isOpen: true,
        title: t('unsaved_changes'),
        content: isEmpty ? t('unsaved_existing_record_warning') : t('unsaved_record_warning'),
        onAccept: onCloseModal,
        onDecline: null,
      };
      dispatch(setConfirmModal(settings));
    } else {
      onCloseModal();
    }
  };

  const handleImport = (e: any) => {
    e.stopPropagation();
    setValues({
      classID: curClass,
      date: moment(curDate).format("YYYY-MM-DD"),
      theme: importData.theme,
      morning: importData.morning,
      afternoon: importData.afternoon,
      notes: importData.notes,
      visit: importData.visit,
    });
    setState("isImported", true);
  };

  const getSettings = useCallback((customData?: any) => {
    const recordValues = customData ? customData : values;
    if(classbookType === "daily") {
      if(isSchoolCare) {
        return {
          classID: curClass,
          date: moment(curDate).format("YYYY-MM-DD"),
          isSchoolCare: true,
          type: "daily",
          //startDate: startDate,
          //endDate: endDate,
          notes: values.notes,
          interestActivities: recordValues.interestActivities,
          relaxationRecreationalActivities: recordValues.relaxationRecreationalActivities,
          preparationTeaching: recordValues.preparationTeaching,
          otherActivities: recordValues.otherActivities,
          internalNote: recordValues.internalNote,
        };
      } else {
        return {
          classID: curClass,
          date: moment(curDate).format("YYYY-MM-DD"),
          isSchoolCare: false,
          type: "daily",
          //startDate: startDate,
          //endDate: endDate,
          theme: recordValues.theme,
          morning: recordValues.morningRaw,
          afternoon: recordValues.afternoonRaw,
          //morningRaw: recordValues.morningRaw,
          //afternoonRaw: recordValues.afternoonRaw,
          notes: recordValues.notes,
          visit: recordValues.visit,
        };
      }
    } else if(classbookType === "weekly") {
      if(isSchoolCare) {
        return {
          classID: curClass,
          date: moment(record.startDate).format("YYYY-MM-DD"),
          isSchoolCare: true,
          type: "weekly",
          //startDate: startDate,
          //endDate: endDate,
          //dateFrom: moment(record.startDate).format("YYYY-MM-DD"),
          //dateTo: moment(record.endDate).format("YYYY-MM-DD"), 
          week: record.week,
          notes: recordValues.notes,
          interestActivities: recordValues.interestActivities,
          relaxationRecreationalActivities: recordValues.relaxationRecreationalActivities,
          preparationTeaching: recordValues.preparationTeaching,
          otherActivities: recordValues.otherActivities,
          internalNote: recordValues.internalNote,
        };
      } else {
        return {
          classID: curClass,
          date: moment(record.startDate).format("YYYY-MM-DD"),
          isSchoolCare: false,
          type: "weekly",
          //startDate: startDate,
          //endDate: endDate,
          //dateFrom: moment(record.startDate).format("YYYY-MM-DD"),
          //dateTo: moment(record.endDate).format("YYYY-MM-DD"), 
          week: record.week,
          theme: recordValues.theme,
          morning: recordValues.morningRaw,
          afternoon: recordValues.afternoonRaw,
          //morningRaw: recordValues.morningRaw,
          //afternoonRaw: recordValues.afternoonRaw,
          notes: recordValues.notes,
          visit: recordValues.visit,
        };
      }
    };
  }, [classbookType, curClass, curDate, endDate, isSchoolCare, record.endDate, record.startDate, record.week, startDate, values]);

  const getContent = useCallback((customData?: any) => {
    const recordValues = customData ? customData : values;
    if(classbookType === "daily") {
      if(isSchoolCare) {
        return {
          classID: curClass,
          date: moment(curDate).format("YYYY-MM-DD"),
          isSchoolCare: true,
          type: "daily",
          startDate: startDate,
          endDate: endDate,
          notes: values.notes,
          interestActivities: recordValues.interestActivities,
          relaxationRecreationalActivities: recordValues.relaxationRecreationalActivities,
          preparationTeaching: recordValues.preparationTeaching,
          otherActivities: recordValues.otherActivities,
          internalNote: recordValues.internalNote,
        };
      } else {
        return {
          classID: curClass,
          date: moment(curDate).format("YYYY-MM-DD"),
          isSchoolCare: false,
          type: "daily",
          startDate: startDate,
          endDate: endDate,
          theme: recordValues.theme,
          morning: recordValues.morning,
          afternoon: recordValues.afternoon,
          morningRaw: recordValues.morningRaw,
          afternoonRaw: recordValues.afternoonRaw,
          notes: recordValues.notes,
          visit: recordValues.visit,
        };
      }
    } else if(classbookType === "weekly") {
      if(isSchoolCare) {
        return {
          classID: curClass,
          isSchoolCare: true,
          type: "weekly",
          startDate: startDate,
          endDate: endDate,
          dateFrom: moment(record.startDate).format("YYYY-MM-DD"),
          dateTo: moment(record.endDate).format("YYYY-MM-DD"), 
          week: record.week,
          notes: recordValues.notes,
          interestActivities: recordValues.interestActivities,
          relaxationRecreationalActivities: recordValues.relaxationRecreationalActivities,
          preparationTeaching: recordValues.preparationTeaching,
          otherActivities: recordValues.otherActivities,
          internalNote: recordValues.internalNote,
        };
      } else {
        return {
          classID: curClass,
          isSchoolCare: false,
          type: "weekly",
          startDate: startDate,
          endDate: endDate,
          dateFrom: moment(record.startDate).format("YYYY-MM-DD"),
          dateTo: moment(record.endDate).format("YYYY-MM-DD"), 
          week: record.week,
          theme: recordValues.theme,
          morning: recordValues.morning,
          afternoon: recordValues.afternoon,
          morningRaw: recordValues.morningRaw,
          afternoonRaw: recordValues.afternoonRaw,
          notes: recordValues.notes,
          visit: recordValues.visit,
        };
      }
    };
  }, [classbookType, curClass, curDate, endDate, isSchoolCare, record.endDate, record.startDate, record.week, startDate, values]);

  const handleSave = (e: any) => {
    if(!state.canClick) return;
    setState("canClick", false);
    e.stopPropagation();
    const newValues = getSettings(values);
    classbookService && classbookService.updateRecord(newValues).then((result: any) => {
      if(result.status === 201) {
        createNotification(t("classbook_updated"), "success");
        const response = result.data.classbookRecords[0];
        const settings = getContent(response);
        dispatch(updateClassbookList(settings));
        if(!isSchoolCare) {
          if(values.theme && values.morning && values.afternoon) {
            const alertData = {
              classID: curClass,
              date: classbookType === "weekly" ? moment(record.startDate).format("YYYY-MM-DD") : moment(curDate).format("YYYY-MM-DD"),
            }
            dispatch(removeClassbookAlert(alertData)); 
          } else {
            const alertData = {
              type: "missingInput",
              classID: curClass,
              date: classbookType === "weekly" ? moment(record.startDate).format("YYYY-MM-DD") : moment(curDate).format("YYYY-MM-DD"),
            }
            dispatch(setClassbookAlerts(alertData)); 
          }
        }
        setState("canClick", true);
        if(!state.isKeepDraftAfterUse) {
          StorageService.removeItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT);
        } else {
          handleImmediateDraftSave();
        }
        onCloseModal();
      } else {
        createNotification(t("something_went_wrong"), "error");
        setState("canClick", true); 
      }
    }).catch((e: any) => {
      createNotification(!isKey(e.response.data.message) ? e.response.data.message : t("something_went_wrong"), "error");
      setState("canClick", true);
    });
  };

  const handleEdit = (e: any) => {
    if(!state.canClick) return;
    if(isMissingInfoEnabled) {
      if(!isSchoolCare) {
        if(values.theme.length === 0 || values.morningRaw.length === 0 || values.afternoonRaw.length === 0) {
          const settings = {
            isOpen: true,
            title: t('required_items'),
            content: t('record_required_items'),
            onAccept: () =>  handleSave(e),
            onDecline: null,
          };
          dispatch(setConfirmModal(settings));
        } else {
          handleSave(e);
        }
      } else {
        handleSave(e);
      }
    } else {
      handleSave(e);
    }
  };

  const handleInput = (name: any, value: any) => {
    setValues((prev: any) => {
      const newState = { ...prev, [name]: value };
      if(isAutosaveEnabled || isDraftEnabled) {
        saveDraftToTempStorage(newState);
      }
      setDraft(name, value);
      return newState;
    });
  };

  const handleInstructions = (value: any) => {
    let notes = values.notes;
    if(notes.endsWith("\"")) {
      notes = notes.substr(0, notes.length - 1)
    }
    notes = `${!notes.startsWith(`${t("edification")}: "`) ? `${t("edification")}: "`: ""}${notes}${notes.length >= 1 ?`\n`: ""}${value.text}${!notes.endsWith("\"") ? `"`: "" }`;
    setValues((prev: any) => ({...prev, notes: notes}));
    notesInput.current.querySelector("textarea").value = notes;
    saveDraftToTempStorage({ ...values, notes });
  };

  const loadInstructions = useCallback(() => {
    classbookService && classbookService.listSentences().then((result: any) => {
      const sentences = result.data.sentences;
      const all = result.data.sentencesCategories.map((sentence: any) => {
        let temp: any = []
        for(let o of sentences){
          if (o.sentenceCategoryID === sentence.sentenceCategoryID) {
             temp.push({...o})
          }
        }
       return { ...sentence, children: temp}
      });
      setState("instructions", all);
    });
  }, [classbookService, setState]);

  const handleIsKeepDraftAfterUse = () => {
    setState("isKeepDraftAfterUse", !state.isKeepDraftAfterUse);
  };

  const handleDrafts = () => {
    const settings = {
      isOpen: true,
      type: 'classbook',
      classbookType: classbookType,
      isSchoolCare: isSchoolCare,
      classID: curClass,
      canSynchronize: false,
      onDraftLoad: handleLoadDraft,
    };
    dispatch(setDraftsModal(settings));
  };

  const handleLoadDraft = useCallback((data: any) => {
    const excludeKeys = ["date", "startDate", "endDate", "week", "draftID", "draftDate"];
    const newData = Object.fromEntries(Object.entries(data).filter(([key]) => !excludeKeys.includes(key)));
    const newValues = Object.assign(values, newData);
    setValues(newValues);
    setWholeDraft(newData);
    setState("draftID", data.draftID);
  }, [values, setState, setWholeDraft]);

  useEffect(() => {
    loadInstructions();
  }, [loadInstructions], []);

  useEffect(() => {
    if(isDraftEnabled && StorageService.existItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT)) {
      const onLoad = () => {
        const getDraft = StorageService.getItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT);
        handleLoadDraft(getDraft);
        //StorageService.removeItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT);
      };
      const onNotLoad = () => {
        StorageService.removeItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT);
      };
      const settings = {
        isOpen: true,
        title: t('classbook_draft'),
        content: t('classbook_draft_load'),
        onAccept: onLoad,
        onDecline: onNotLoad,
      };
      dispatch(setConfirmModal(settings));
    }
  }, [], []);

  useEffect(() => {
    if(modalRef.current && headerRef.current && footerRef.current) {
      const modalHeight = state.modalIsFullscreen ? browserData.height : modalRef.current.clientHeight;   
      const headerHeight = headerRef.current.clientHeight; 
      const footerHeight = footerRef.current.clientHeight; 
      const bodyHeight = modalHeight - headerHeight - footerHeight; 
      setState("bodyHeight", bodyHeight);
    } else {
      if(!state.updateRefs) {
        setState("updateRefs", true);
      }
    }
    if(state.updateRefs) {
      setState("updateRefs", false);
    }
  }, [state.modalIsFullscreen, browserData.height, state.updateRefs, setState], [state.modalIsFullscreen, browserData.height, state.updateRefs]);

  useEffect(() => {
    setState("modalIsFullscreen", smallDevice ? true : false);
  }, [browserData.height, smallDevice, setState], [browserData.height]);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (StorageService.existItem(config.LOCALSTORAGE_CLASSBOOK_DRAFT)) {
        event.preventDefault();
        event.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const loadRecord = useCallback(() => {
    const date = classbookType === "weekly" ? recordDates[0] : curDate;
    classbookService && classbookService.listRecords(curClass, date).then((result: any) => {
      if(result) {
        if(result.data) {
          if(result.data.classbookRecords) {
            if(classbookType === "weekly") {
              const data = result.data.classbookRecords.filter((item: any) => item.dateFrom === date).length === 0 ? null : result.data.classbookRecords.find((item: any) => item.dateFrom === date);
              if(data) {
                const updateData = getContent(data);
                const updateValues = getValues(data);
                setValues(updateValues);
                dispatch(updateClassbookList(updateData));
                setState("isLoaded", true);
              } else {
                setState("isLoaded", true);
                createNotification(t("classbook_record_failed_update"), "error");
              }
            } else {
              const data = result.data.classbookRecords.filter((item: any) => item.date === date).length === 0 ? null : result.data.classbookRecords.find((item: any) => item.date === date);
              if(data) {
                const updateData = getContent(data);
                const updateValues = getValues(data);
                setValues(updateValues);
                dispatch(updateClassbookList(updateData));
                setState("isLoaded", true);
              } else {
                setState("isLoaded", true);
                createNotification(t("classbook_record_failed_update"), "error");
              }
            }
          } else {
            setState("isLoaded", true);
            createNotification(t("classbook_record_failed_update"), "error");
          }
        } else {
          setState("isLoaded", true);
          createNotification(t("classbook_record_failed_update"), "error");
        }
      } else {
        setState("isLoaded", true);
        createNotification(t("classbook_record_failed_update"), "error");
        return;
      }
    }).catch(() => {
      setState("isLoaded", true);
      createNotification(t("classbook_record_failed_update"), "error");
    });
  }, [classbookService, classbookType, curClass, curDate, recordDates, t, dispatch, getSettings, getValues, setState]);

  useEffect(() => {
    if(!state.isLoaded) {
      loadRecord();
    }
  }, [state.isLoaded, loadRecord], []);

  return (
    <Modal 
      open={true}
      onClose={handleClose}
      disableEscapeKeyDown={true}
      isFullscreen={state.modalIsFullscreen}
    >
      <div className={classes.root} data-cy={isCypress() ? "classbookHandleModal" : null} ref={modalRef}>
        <div className={classes.header} ref={headerRef}>
          <div className={classes.wrapper}>
            <p data-clarity-unmask="true">
              {isEmpty ? t('create_record') : t('edit_record')}
              &nbsp;
              {
                classbookType === "weekly" ? (
                  <>{t('week')} {values.week}. ({DateFormat(dateFrom, "default", languageData, t)} - {DateFormat(dateTo, "default", languageData, t)})</>
                ) : (
                  <>{DateFormat(moment(curDate),"default",languageData,t)}</>
                )
              }
            </p>
          </div>
          <div className={classes.buttons}>
            {
              isDraftEnabled ? (
                <IconButton className={`${classes.button} smallIcon`} onClick={handleDrafts} data-cy={isCypress() ? "draftsButton" : null} tooltip={t('drafts')} tooltipPosition='bottom'>
                  <SVG src="draft"/>
                </IconButton>
              ) : null
            }
            {
              !smallDevice ? (
                <IconButton className={`${classes.button} smallIcon`} onClick={handleFullscreen} data-cy={isCypress() ? "fullscreenButton" : null} tooltip={state.modalIsFullscreen ? t('mode_window') : t('mode_fullscreen')} tooltipPosition='bottom'>
                  {state.modalIsFullscreen ? (<SVG src="fullscreen-exit"/>) : (<SVG src="fullscreen-enter"/>)}
                </IconButton>
              ) : null
            }
            <CloseButton onClick={handleClose} dataCy="timesButton"/> 
          </div>
        </div>
        <div className={classes.body}>
          {
            state.isLoaded ? (
              <div className={classes.bodyWrapper}>
                {
                  isSchoolCare ? (
                    <>
                      <div className={classes.item}>
                        <Input label={t('additional_notes')} name='notes' multiline={true} value={values.notes} onChange={handleInput} dataCy='additionalNotes' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <Input label={t('interest_activities')} name='interestActivities' multiline={true} value={values.interestActivities} onChange={handleInput} dataCy='interestActivities' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <Input label={t('relaxation_recreational_activities')} name='relaxationRecreationalActivities' multiline={true} value={values.relaxationRecreationalActivities} onChange={handleInput} dataCy='relaxationRecreationalActivities' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <Input label={t('preparation_teaching')} name='preparationTeaching' multiline={true} value={values.preparationTeaching} onChange={handleInput} dataCy='preparationTeaching' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <Input label={t('other_activities')} name='otherActivities' multiline={true} value={values.otherActivities} onChange={handleInput} dataCy='otherActivities' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <Input label={t('internal_note')} name='internalNote' multiline={true} value={values.internalNote} onChange={handleInput} dataCy='internalNote' dataClarityUnmask='true'/>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={classes.item}>
                        <Input label={`${t('theme')} ${isMissingInfoEnabled ? `<small>${t('required')}</small>` : ''}`} name='theme' multiline={true} value={values.theme} onChange={handleInput} dataCy='theme' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <RichTextEditor uid="morning" label={`${t('morning_educational_activities')} ${isMissingInfoEnabled ?  `<small>${t('required')}</small>` : ''}`} name='morningRaw' useName={true} value={values.morningRaw} onChange={handleInput} dataCy='morning' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <RichTextEditor uid="morning" label={`${t('afternoon_educational_activities')} ${isMissingInfoEnabled ?  `<small>${t('required')}</small>` : ''}`} name='afternoonRaw' useName={true} value={values.afternoonRaw} onChange={handleInput} dataCy='afternoon' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <Select className={classes.select} items={state.instructions} label={t('instructions')} inputLabel={t('instructions')} selected={null} setSelected={handleInstructions} dataCy='instructions'/>
                      </div>
                      <div className={classes.item}>
                        <Input label={t('additional_notes')} name='notes' multiline={true} value={values.notes} onChange={handleInput} customRef={notesInput} dataCy='notes' dataClarityUnmask='true'/>
                      </div>
                      <div className={classes.item}>
                        <Input label={t('record_visits')} name='visit' multiline={true} value={values.visit} onChange={handleInput} dataCy='visit' dataClarityUnmask='true'/>
                      </div>
                    </>
                  )
                }
              </div>
            ) : (
              <div className={classes.loadingWrapper}>
                <div className={classes.spinner}>
                  <CircularProgress/>
                </div>
              </div>
            )
          }
        </div>
        <div className={classes.footer} ref={footerRef}>
          {
            (isDraftEnabled || isAutosaveEnabled) ? (
              <span className={classes.info}>
                {
                  isAutosaveEnabled ? (
                    <div className={classes.infoDetail}>
                      <SVG src="info-circle-outlined"/>
                      {t('classbook_autosave_enabled')}
                    </div>
                  ) : null
                }
                {
                  (isDraftEnabled && Object.keys(filterNotExistingValues(draft)).length > 0) ? (
                    <Switch labelLeft={t('keep_draft_after_use')} onChange={handleIsKeepDraftAfterUse} checked={state.isKeepDraftAfterUse} dataCy="isKeepDraftAfterUse"/>
                  ) : null
                }
              </span>
            ) : null
          }
          <div className={classes.footerButtons}>
            {
              (isEmpty && isImport && !state.isImported) ? (
                <NormalButton className={classes.importButton} buttonType="tertiary" onClick={handleImport} dataCy='importPreviousDataButton'>
                  {t('classbook_import_previous_day')}
                </NormalButton>
              ) : null
            }
            <NormalButton buttonType="secondary" onClick={handleClose} dataCy='cancelButton'>
              {t('cancel')}
            </NormalButton>
            <NormalButton disabled={!state.canClick} buttonType={isEmpty ? 'primary' : (isEmptied ? 'clear' : 'primary')} onClick={handleEdit} dataCy={isEmptied ? 'deleteButton' : 'saveButton'}>
              {isEmpty ? t('create') : (isEmptied ? t('remove_record') : t('save_record'))}
            </NormalButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ClassbookHandleModal;